function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import CheckCircleOutlined from '@material-ui/icons/CheckCircleOutlined';
import { Typography } from '../Typography';

var styles = function styles(theme) {
  return {
    validator: {
      fontSize: 14,
      marginBottom: 6
    },
    checkCircle: {
      color: theme.palette.grey['500'],
      marginRight: 8,
      verticalAlign: 'middle',
      fontSize: 18
    },
    fail: {
      color: theme.palette.error.main
    },
    success: {
      color: theme.palette.secondary.main
    }
  };
};

var PasswordValidatorCore = function PasswordValidatorCore(_ref) {
  var _classNames;

  var classes = _ref.classes,
      passwordCriteria = _ref.passwordCriteria,
      value = _ref.value,
      values = _ref.values;
  return (
    /*#__PURE__*/
    React.createElement(Typography, {
      "data-e2e": passwordCriteria.key,
      key: passwordCriteria.key,
      color: value && passwordCriteria.validationFunc(value, values) ? 'error' : 'textPrimary',
      className: classes.validator
    },
    /*#__PURE__*/
    React.createElement(CheckCircleOutlined, {
      className: classNames(classes.checkCircle, (_classNames = {}, _defineProperty(_classNames, classes.success, value && !passwordCriteria.validationFunc(value, values)), _defineProperty(_classNames, classes.fail, value && passwordCriteria.validationFunc(value, values)), _classNames))
    }), passwordCriteria.displayText)
  );
};

export var PasswordValidator = withStyles(styles)(PasswordValidatorCore);